import { host } from '../config/env'

export const saveUserBank = params => {
  return axios({
    url: `${host.eqshow}/showker/cash/saveUserBank`,
    method: 'post',
    data: {
      ...params
    }
  })
}

export const getBankInfo = params => {
  return axios({
    url: `${host.eqshow}/showker/cash/getBankInfo`,
    method: 'post',
    data: {
      ...params
    }
  })
}

export const getRealName = params => {
  return axios({
    url: `${host.eqshow}/showker/cash/getRealName`,
    method: 'post',
    data: {
      ...params
    }
  })
}
